var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section__lk-content container-shadow fill-white"},[_c('div',{staticClass:"section__lk-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"section__lk-content-items mt-0"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }